<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-people-fill">&nbsp; Manage customers</h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="reloadData()" :disabled="loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->                              
      <div class="row p-0">

        <div class="col p-0">
          <div class="input-group w-100">
            <span class="input-group-text">Search</span>
            <input class="form-control" type="text" v-model.trim="searchKey" @change="reloadData()">
            <button class="btn btn-primary bi-search" @click="reloadData()" :disabled="loading"></button>
          </div>
        </div>
        
        <div class="col p-0">
        </div>
        <div class="col p-0">
        </div>
        
        <div class="col p-0">
          <button class="btn btn-success bi-plus-circle w-100" @click="showAddCustomer()" :disabled="loading">&nbsp; Add Customer</button>
        </div>

      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="w-20">Name</th>
          <th class="w-15">Phone</th>
          <th class="w-15">Type</th>
          <th class="w-10 text-center">Balance</th>
          <th>Cars</th>
          <th class="text-center w-50px"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="customer in customers" :key="customer._id" v-bind:class="rowColor(customer.balance)">
          <td class="w-20">{{ customer.name }}</td>
          <td class="w-15">{{ customer.phone }}</td>
          <td class="w-15">{{ translate_type(customer.type) }}</td>
          <td class="w-10 text-center">{{ formatMoney(customer.balance) }}</td>
          <td>
            <table>
              <tr v-for="car, i in customer.cars" :key="i">
                <td class="w-50">{{ car.brand }}</td>
                <td class="w-20">{{ car.miles }}</td>
                <td class="w-30 ltr">{{ car.plate.join(' ') }}</td>
              </tr>
            </table>
          </td>
          <td class="dropstart text-center w-50px">
            <a data-bs-toggle='dropdown' class="btn btn-sm btn-secondary p-1"><span class="bi-three-dots-vertical"></span></a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item bi-receipt" @click="viewInvoices(customer)">Invoices</a></li>
              <li><a class="dropdown-item bi-pencil-fill" @click="showEditCustomer(customer._id)">Edit</a></li>
              <li v-if="$store.getters.access('customer_deposit')"><a class="dropdown-item text-success bi-cash-coin" @click="showDeposit(customer)">Deposit</a></li>
              <li v-if="$store.getters.access('customer_withdrawl')"><a class="dropdown-item text-danger bi-cash-stack" @click="showWithdrawl(customer)">withdrawl</a></li>
              <li v-if="$store.getters.access('customer_statement')"><a class="dropdown-item bi-bank2" @click="showStatmenet(customer)">Statement</a></li>
              <li v-if="$store.getters.isSuper"><a class="dropdown-item bi-trash text-danger" @click="delCustomer(customer)">Delete</a></li>
            </ul>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <div id="depositModal" ref="depositModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title text-success">Deposit to "{{ customer.name }}" Balance</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text text-primary w-50">Current Balance</span>
              <span class="input-group-text text-primary w-50">{{ formatMoney(customer.balance) }}</span>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Amount</span>
              <input class="form-control" type="number" v-model.number="new_deposit.amount">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Note</span>
              <input class="form-control" type="text" v-model.trim="new_deposit.note">
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="confirmDeposit()">Confirm Deposit</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="withdrawlModal" ref="withdrawlModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title text-danger">Withdrawl from "{{ customer.name }}" Balance</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text text-primary w-50">Current Balance</span>
              <span class="input-group-text text-primary w-50">{{ formatMoney(customer.balance) }}</span>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Amount</span>
              <input class="form-control" type="number" v-model.number="new_withdrawl.amount">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Note</span>
              <input class="form-control" type="text" v-model.trim="new_withdrawl.note">
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="confirmWithdrawl()">Confirm Withdrawl</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="statementModal" ref="statementModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title"> Customer "{{ customer.name }}" Statement</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text text-primary fw-bold w-50">Current Balance</span>
              <span class="input-group-text text-primary fw-bold text-center d-inline-block w-50">{{ formatMoney(customer.balance) }}</span>
            </div>
            <table class="table table-sm table-striped table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th>Date</th>
                  <th>Type</th>
                  <th class="text-center">Amount</th>
                  <th>Note</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="x in statement" :key="x._id" v-bind:class="{'deposit': 'table-success', 'withdrawl': 'table-danger', 'purchase': 'table-primary'}[x.type]">
                  <td>{{ x.timestamp }}</td>
                  <td>{{ x.type }}</td>
                  <td class="text-center">{{ formatMoney(x.amount) }}</td>
                  <td>
                    {{ x.note  }}
                    <span v-if="x.invoice" @click="viewInvoice(x.invoice)" class="btn btn-link my-0 py-0">Invoice: {{ x.invoice }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Close</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="loadStatemenet()">Reload</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
    <Invoice ref="invoice"></Invoice>
    <AddCustomer ref="addCustomer" v-model:loading="loading"></AddCustomer>
    <EditCustomer ref="editCustomer" v-model:loading="loading"></EditCustomer>
  </div>

</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  import AddCustomer from '@/components/AddCustomer.vue';
  import EditCustomer from '@/components/EditCustomer.vue';
  import Invoice from '@/components/Invoice.vue';
  export default {
    name: 'CustomersPage',
    components: {
      AddCustomer,
      EditCustomer,
      Invoice,
    },
    data(){
      return {
        loading: false,
        customers: [],
        searchKey: '',
        filter: '',
        customer:{
          balance: 0,
        },
        statement: [],
        new_deposit:{
          customer_id: '',
          amount: '',
          note: '',
        },
        new_withdrawl:{
          customer_id: '',
          amount: '',
          note: '',
        },
      }
    },
    created() {
      this.reloadData();
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async reloadData(){
        this.loading = true;
        this.customers = [];
        var ack = await this.$service.getcustomers({searchKey: this.searchKey});
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.customers = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async showAddCustomer(){
        await this.$refs.addCustomer.show(async(customer)=>{
          console.log(customer);
          await this.reloadData();
        });
      },
      //**********************************************************
      async showEditCustomer(customer_id){
        await this.$refs.editCustomer.show(customer_id, async()=>{
          await this.reloadData();
        });
      },
      //**********************************************************
      async delCustomer(customer){
        var reply = await this.$swal.fire({
          title: "Confirm Delete",
          html: `Are you sure you want to delete the customer <b>${customer.name}</b>`,
          icon: "error", showCancelButton: true, focusCancel: true,
          confirmButtonText: "Confirm Delete", confirmButtonColor: "#d33", 
        });
        if(!reply.isConfirmed) return;
        this.loading = true;
        var ack = await this.$service.delCustomer({ id: customer._id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Customer Deleted Successfuly', 'success');
          this.reloadData();
        }
        this.loading = false;
      },
      //**********************************************************
      viewInvoices(customer){
        this.$router.push({
            name: 'Invoices',
            params: { cid: customer._id }
        })
      },

      //**********************************************************
      async showDeposit(customer){
        this.customer = customer;
        this.new_deposit.customer_id = customer._id;
        this.new_deposit.amount = '';
        this.new_deposit.note = '';
        $('#depositModal').modal('show');
      },
      //**********************************************************
      async confirmDeposit(){
        if(!this.new_deposit.customer_id || !this.new_deposit.amount){
          return this.$toast('Some Fields are empty', 'warning');
        }
        if(isNaN(this.new_deposit.amount) || this.new_deposit.amount <= 0){
          return this.$toast('Invalid Amount', 'warning');
        }
        this.loading = true;
        var ack = await this.$service.customerDeposit(this.new_deposit);
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          $('#depositModal').modal('hide');
          this.$toast('Deposit Succeed', 'success');
          this.reloadData();
        }
        this.loading = false;
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      async showWithdrawl(customer){
        this.customer = customer;
        this.new_withdrawl.customer_id = customer._id;
        this.new_withdrawl.amount = '';
        this.new_withdrawl.note = '';
        $('#withdrawlModal').modal('show');
      },
      //**********************************************************
      async confirmWithdrawl(){
        if(!this.new_withdrawl.customer_id || !this.new_withdrawl.amount){
          return this.$toast('Some Fields are empty', 'warning');
        }
        if(isNaN(this.new_withdrawl.amount) || this.new_withdrawl.amount <= 0){
          return this.$toast('Invalid Amount', 'warning');
        }
        this.loading = true;
        var ack = await this.$service.customerWithdrawl(this.new_withdrawl);
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          $('#withdrawlModal').modal('hide');
          this.$toast('Withdrawl Succeed', 'success');
          this.reloadData();
        }
        this.loading = false;
      },
      //**********************************************************
      rowColor(balance){
        if(balance == 0) return '';
        if(balance > 0) return 'table-success';
        if(balance < 0) return 'table-danger';
      },
      //**********************************************************
      async showStatmenet(customer){
        this.customer = customer;
        var ack = await this.loadStatemenet();
        if(ack){
          $('#statementModal').modal('show');
        }
        else{
          this.$toast(ack.state);
        }
      },
      //**********************************************************
      async loadStatemenet(){
        this.loading = true;
        this.statemenet = [];
        var ack = await this.$service.customerStatement({customer_id: this.customer._id});
        if(ack.state == 'OK'){
          this.statement = ack.data.wallet;
          this.customer.balance = ack.data.balance;
        }
        this.loading = false;
        return ack;
      },
      //**********************************************************
      async viewInvoice(invoice_id){
        this.loading = true;
        await this.$refs.invoice.view(invoice_id);
        this.loading = false;
      },
      //**********************************************************
      translate_type(type){
        if(type == 'customer') return 'Customer';
        if(type == 'wholesaler') return 'Wholsaler';
        if(type == 'premium_ws') return 'Premium Wholsaler';
        return "";
      },
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  